import { createComparator } from '@tmapy/utils';
import { transformInfoConfigFromTinker } from './transformInfoConfigFromTinker';
export const buildInfoConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const infoServices = tinkerConfig.mapInfos.edges
        .map((edge) => edge.node)
        .sort(createComparator((asc) => -asc.order, (asc) => asc.id))
        .map((mapInfo) => {
        nonTranslatableResourceStrings[`info.${mapInfo.nameId}`] = mapInfo.title;
        return mapInfo;
    })
        .map(transformInfoConfigFromTinker)
        .filter(Boolean);
    return {
        services: infoServices,
        coordsInfo: tinkerConfig.maps.edges[0]?.node.coordsInfo,
    };
};
//# sourceMappingURL=buildInfoConfig.js.map